import { render, staticRenderFns } from "./DsVideoDetails.vue?vue&type=template&id=1b905d0e&scoped=true"
import script from "./DsVideoDetails.vue?vue&type=script&lang=js"
export * from "./DsVideoDetails.vue?vue&type=script&lang=js"
import style0 from "./DsVideoDetails.vue?vue&type=style&index=0&id=1b905d0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b905d0e",
  null
  
)

export default component.exports